import { Component, OnInit } from '@angular/core';
import { JwtService } from 'src/app/jwt.service';
import { ConsultaGerencial, ConsultaGerencialResponse } from 'src/app/persistences/consulta-gerencial';
import { ConsultaGerencialService } from 'src/app/services/consulta-gerencial.service';
import { ClienteSingletonService } from 'src/app/singletons/cliente-singleton.service';

@Component({
  selector: 'app-consulta-gerencial',
  templateUrl: './consulta-gerencial.component.html',
  styleUrls: ['./consulta-gerencial.component.css']
})
export class ConsultaGerencialComponent implements OnInit {
  consultasGerenciais: ConsultaGerencial[];
  consultaSelecionada: ConsultaGerencial;
  respostaConsulta: ConsultaGerencialResponse[];
  isPesquisando = false;

  constructor(
    private consultaGerencialService: ConsultaGerencialService,
    private clienteSingletonService: ClienteSingletonService,
    private jwtService: JwtService
  ){}

  ngOnInit(): void {
    this.jwtService.checkLogin();
    this.consultaGerencialService.getAllConsultasGerenciais().subscribe((response)=> {
      this.consultasGerenciais = response.filter((consulta)=> consulta.flAtivo === true);
    })
  }

  executarAcaoConsulta(consulta: ConsultaGerencial){
    this.isPesquisando = true;
    this.respostaConsulta = [];
    const cdFilial = this.clienteSingletonService.getClienteEstatico().getClienteFilial.getCdFilial;
    const cdCliente = this.clienteSingletonService.getClienteEstatico().getCdCliente;
    this.consultaGerencialService.getAcessoAcao(cdCliente, cdFilial, consulta.cdAcesso).subscribe((response)=>{
      this.respostaConsulta = response;
      this.isPesquisando = false
    },
    (error) => {
      this.isPesquisando = false;
    });
    this.consultaSelecionada = consulta;
  }

  voltarParaLista(){
    this.consultaSelecionada = null;
  }

}
